import { useState } from 'react'
import { Modal } from 'shared/components/modal'
import { DISHtml } from 'shared'
import { DonateButton } from 'ppp'
import classNames from 'classnames'

import { AdventIcon } from './adventskranz_icon'

export const AdventMatchingNotice = (props) => {
  if (!props.activeFeatureFlag || props.active_matching_fund) return null

  const [show, setShow] = useState(false)
  const onHide = () => setShow(false)

  const handleClick = () => setShow(true)

  return (
    <>
      <div className='w-full flex items-center p-2 mb-2' style={{ backgroundColor: '#931C38', color: '#FFF4D2' }}>
        <AdventIcon />
        <p className='mb-0'>
          <strong>{I18n.t('projects.show.stats.advent_banner_headline')}</strong>
          <br />
          <span dangerouslySetInnerHTML={{ __html: I18n.t('projects.show.stats.advent_banner_text_html') }}></span>
          <a onClick={handleClick} className='font-normal' style={{ color: '#FFF4D2' }}>
            <u>{I18n.t('projects.show.stats.advent_banner_read_more')}</u>
          </a>
        </p>
      </div>
      <Modal
        show={show}
        onHide={onHide}
        content={<ModalContent project={props.project} status={props.status} onHide={onHide} />}
        header={I18n.t('projects.show.stats.advent_banner_modal_headline')}
      />
    </>
  )
}

const ModalContent = (props) => {
  const locale = (I18n.locale === 'en') ? 'en-GB' : 'de'
  const date = new Intl.DateTimeFormat(locale).format(new Date())

  return (
    <>
      <div className='flex flex-col text-center items-center' style={{ backgroundColor: '#931C38', color: '#FFF4D2' }}>
        <div className='my-3'>
          <p>
            <DISHtml value={I18n.t('projects.show.stats.advent_banner_modal_intro')} />
          </p>
          <p>
            <DISHtml
              value={I18n.t('projects.show.stats.advent_banner_modal_duration', {date: date})}
            />
          </p>
          <p>
            <DISHtml value={I18n.t('projects.show.stats.advent_banner_modal_budget')} />
          </p>
        </div>
        <div className={classNames('d-flex text-center text-white')} style={{ height: '80px' }}>
          <AdventIcon />
        </div>
      </div>
      <div>
        <div>
          <p className='my-4'>
            <DISHtml
              value={I18n.t('projects.show.stats.advent_banner_modal_description_1')}
            />
          </p>
          <p className='my-4'>
            <DISHtml
              value={I18n.t('projects.show.stats.advent_banner_modal_description_2')}
            />
          </p>
        </div>
        <div className='d-flex justify-content-between'>
          <button type='button' className='simulated-link' onClick={props.onHide}>
            {I18n.t('misc.close')}
          </button>
          <DonateButton
            project={props.project}
            status={props.status}
            additionalClass='btn-large'
            gaAction='click donate_button__matching_event'
          />
        </div>
      </div>
    </>
  )
}
